import type { IconSvgObject } from './types';

const Setting06Icon: IconSvgObject = [
  ["path", { d: "M9 8L15 16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.2919 20.007L21.702 12.5068C21.8859 12.194 21.8859 11.806 21.702 11.4931L17.2919 3.99312C17.1122 3.6876 16.7843 3.5 16.4299 3.5H7.57194C7.21758 3.5 6.88968 3.68754 6.71001 3.99298L2.29825 11.4929C2.11416 11.8059 2.11416 12.194 2.29824 12.507L6.71001 20.0071C6.88968 20.3125 7.21759 20.5001 7.57195 20.5001H16.4299C16.7843 20.5001 17.1122 20.3125 17.2919 20.007Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Setting06Icon;
